import { SitemapView } from 'volto-ministerio-publico-federal/components';

const Sitemap = (props) => <SitemapView {...props} />;

export default Sitemap;
